import React from 'react';
import { Hero } from '@components/basics/Hero';
import { ChannelHeroFragmentDoc, type FragmentType, getFragment, gql } from '@graphql/reactQuery';

/*#__PURE__*/ gql(/* GraphQL */ `
  fragment ChannelHero on Channel {
    coverImage {
      id
      url
    }
  }
`);

export const ChannelHero = ({
  channelFrag,
}: {
  channelFrag: FragmentType<ChannelHeroFragmentDoc>;
}) => {
  const { coverImage } = getFragment(ChannelHeroFragmentDoc, channelFrag);

  const hasBannerImage = !!coverImage?.url;

  return (
    <Hero
      backgroundImageSrc={!!hasBannerImage ? coverImage.url : '/images/sound_letter_s.svg'}
      variant="channel"
    />
  );
};
